import { generateSignedUrl } from '../firebase/functions';

export const uploadFileToS3 = async (file, folder) => {
  try {
    const response = await generateSignedUrl({
      fileName: file.name,
      fileType: file.type,
      folder,
    });

    const { signedUrl, key } = response.data;

    const uploadResponse = await fetch(signedUrl, {
      method: 'PUT',
      headers: { 'Content-Type': file.type },
      body: file,
    });

    if (!uploadResponse.ok) {
      throw new Error(`Failed to upload file: ${uploadResponse.statusText}`);
    }

    const uploadedFileUrl = signedUrl.split('?')[0];

    return { url: uploadedFileUrl, key };
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};

export const deleteFileFromS3 = async (key, folder) => {
  try {
    const response = await generateSignedUrl({
      fileName: key,
      folder,
      isDelete: true,
    });

    const { signedUrl } = response.data;

    const deleteResponse = await fetch(signedUrl, {
      method: 'DELETE',
    });

    if (!deleteResponse.ok) {
      throw new Error(`Failed to delete file: ${deleteResponse.statusText}`);
    }

    return true;
  } catch (error) {
    console.error('Error deleting file:', error);
    throw error;
  }
};
